module.exports = __webpack_public_path__ + "img/sect4-44.35e6b0a0.png";